import { LoginFormSection } from "@/design-system/Organisms"; 

export const LoginTemplate = () => {
  return (
    <>
      <LoginFormSection /> 
    </>
  );
};

export default LoginTemplate;
